import(/* webpackMode: "eager", webpackExports: ["BlocksRenderer"] */ "/codebuild/output/src828441159/src/client/node_modules/@strapi/blocks-react-renderer/dist/BlocksRenderer.mjs");
